import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { TypeaheadUsuarioComponent } from './typeahead';
import { UsuarioAlteraSenhaModalComponent } from './altera-senha-modal';
import { UsuarioPopulaAgrupamentoPerfilModalComponent } from './popula';
import { UsuarioPipesModule } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule.forRoot(),
        UsuarioPipesModule
    ],
    declarations: [
        // Components
        TypeaheadUsuarioComponent,
        UsuarioAlteraSenhaModalComponent,
        UsuarioPopulaAgrupamentoPerfilModalComponent
    ],
    exports: [
        // Components
        TypeaheadUsuarioComponent,
        UsuarioAlteraSenhaModalComponent,
        UsuarioPopulaAgrupamentoPerfilModalComponent,

        // Pipes
        UsuarioPipesModule
    ]
})
export class UsuarioSharedModule { }
